module.exports = __webpack_public_path__ + "static/media/footer-selo.32cd80d7.png";